import React from 'react';
import { StyleSheet, Text, TouchableOpacity, View } from 'react-native';
import { colors } from '@constants/theme';
import Info from '@assets/svg/MyDeliveries/Info';
import { fontFamily } from '@utils/styles';

interface ContentItem {
  icon: React.ReactNode;
  text: string;
  value: string | number;
  list?: Array<any>;
}

interface CratePacketItemsInfoProps {
  Content: ContentItem[];
  onPressInfo: (data: { title: string; list: Array<any> }) => void;
}

const CratePacketItemsInfo: React.FC<CratePacketItemsInfoProps> = ({ Content, onPressInfo }) => {
  return (
    <View style={styles.detailsOuterCard}>
      {Content?.map((content) => (
        <View key={content.text} style={styles.detailsCard}>
          <View style={styles.detailsInnercard}>
            <View style={{ alignItems: "center", flexDirection: "row" }}>
              <View style={{ marginLeft: 4, marginTop: 4 }}>{content.icon}</View>
              <Text style={styles.title}>{content.text}</Text>
              {content?.list && content?.list.length ? (
                <TouchableOpacity
                  style={{ paddingVertical: 5, paddingHorizontal: 5 }}
                  testID="info_tooltip_modal"
                  onPress={() =>
                    onPressInfo({
                      title: content.text,
                      list: content.list || [],
                    })
                  }
                >
                  <Info width={18} height={18} />
                </TouchableOpacity>
              ) : (
                <></>
              )}
            </View>
            <View>
              <Text style={styles.value}>{content.value}</Text>
            </View>
          </View>
        </View>
      ))}
    </View>
  );
};

const styles = StyleSheet.create({
  detailsOuterCard: {
    flexDirection: "row",
    paddingVertical: 8,
    flexWrap: 'wrap'
  },
  detailsInnercard: {
    flexDirection: "row",
    backgroundColor: "rgba(0, 0, 0, 0.03)",
    marginTop: 0,
    margin: 8,
    padding: 6,
    borderRadius: 12,
    flex: 1,
    alignItems: "center",
    justifyContent: "space-between",
  },
  detailsCard: {
    flexDirection: "row",
    width: '50%',
  },
  title: {
    marginLeft: 4,
    marginBottom: 4,
    fontFamily: fontFamily.bold,
    fontSize: 14,
    color: colors.black06,
  },
  value: {
    fontSize: 16,
    fontFamily: fontFamily.bold,
    color: colors.mediumBlack,
    marginRight: 4,
  },
});

export default CratePacketItemsInfo;
